<template>
    <v-dialog width="650px" v-model="isOpenHolidaysForm">
        <v-card elevation="0">
            <v-card-title primary-title class="mb-4">
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    <v-icon left> mdi-beach </v-icon>
                    {{
                        holidaysFormType == 'CREATE'
                            ? 'Estableciendo'
                            : 'Editando'
                    }}
                    Vacaciones
                </div>
                <div
                    v-else
                    class="font-weight-light primary--text text-h4 ml-2"
                >
                    <v-icon large left> mdi-beach </v-icon>
                    {{
                        holidaysFormType == 'CREATE'
                            ? 'Estableciendo'
                            : 'Editando'
                    }}
                    Vacaciones
                </div>
            </v-card-title>
            <!-- <v-divider class="test mb-4"></v-divider> -->

            <v-card-text>
                <h4 class="font-weight-light primary--text px-2">
                    Filtrar Selección de comercial
                </h4>
                <v-row v-if="hasAdminPermission && opciones" dense >
                    <v-col cols="12" md="6">
                        <v-card elevation="0">
                            <!-- <v-row class="pa-4">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Filtrar por Rol
                                </h4>
                            </v-row>
                            <v-divider class="mx-2"></v-divider> -->
                            <v-row no-gutters>
                                <v-select
                                    class="px-4"
                                    :items="opciones.cuenta.rol"
                                    item-text="human"
                                    item-value="encoded"
                                    v-model="rol"
                                    persistent-hint
                                    :hint="
                                        rol.length
                                            ? 'Elimine los filtros para ver la selección completa'
                                            : ''
                                    "
                                    multiple
                                    prepend-inner-icon="mdi-gamepad-outline"
                                    label="Elija un rol"
                                    clearable
                                >
                                    <template #item="{ item }">
                                        {{ item.human }}
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            dark
                                            color="red lighten-1"
                                            >{{ item.human }}</v-chip
                                        >
                                    </template>
                                </v-select>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        :class="!$vuetify.breakpoint.mdAndDown ? '' : 'pt-2'"
                    >
                        <v-card elevation="0">
                            <!-- <v-row class="pa-4">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Filtrar por Tipo
                                </h4>
                            </v-row>
                            <v-divider class="mx-2"></v-divider> -->
                            <v-row no-gutters>
                                <v-select
                                    class="px-4"
                                    :items="opciones.cuenta.tipoComercial"
                                    item-text="human"
                                    item-value="encoded"
                                    v-model="types"
                                    persistent-hint
                                    :hint="
                                        types.length
                                            ? 'Elimine los filtros para ver la selección completa'
                                            : ''
                                    "
                                    multiple
                                    prepend-inner-icon="mdi-filter"
                                    label="Elija un tipo"
                                    clearable
                                >
                                    <template #item="{ item }">
                                        {{ item.human }}
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            dark
                                            color="orange lighten-1"
                                            >{{ item.human }}</v-chip
                                        >
                                    </template>
                                </v-select>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <h4
                    v-if="hasAdminPermission"
                    class="font-weight-light primary--text px-2 pt-4"
                >
                    Seleccionar Comercial y Tipo de Vacaciones
                </h4>
                <v-row dense>
                    <v-col v-if="hasAdminPermission" cols="12" md="6">
                        <v-card elevation="0" dense class="pt-2 px-2">
                            <!-- <v-row class="pb-3 pt-2">
                                <h4 class="font-weight-light primary--text px-2">
                                    Comercial Seleccionado
                                </h4>
                            </v-row>
                            <v-divider class="mx-n1"></v-divider> -->
                            <v-row no-gutters>
                                <v-autocomplete
                                    class="px-4"
                                    :items="comercialesFilter"
                                    v-model="holidaysForm.commercial"
                                    item-text="nombreCompleto"
                                    item-value="id"
                                    prepend-inner-icon="mdi-account"
                                    label="Comercial"
                                    clearable
                                >
                                    <template #item="{ item }">
                                        <v-row>
                                            <v-col cols="9">
                                                {{ item.nombreCompleto }}
                                            </v-col>
                                            <v-col cols="3">
                                                <v-icon
                                                    :color="
                                                        estadoComercial[item.estado]
                                                    "
                                                    class="
                                                        d-flex
                                                        justify-center
                                                        overline
                                                    "
                                                >
                                                    mdi-circle
                                                </v-icon>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip small color="lime">{{
                                            item.nombreCompleto
                                        }}</v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" :md="hasAdminPermission ? '6' : '12'">
                        <v-card elevation="0" dense class="pt-2 px-2">
                            <!-- <v-row class="pb-3 pt-2">
                                <h4 class="font-weight-light primary--text px-2">
                                    Tipo de Vacaciones
                                </h4>
                            </v-row>
                            <v-divider class="mx-n1"></v-divider> -->
                            <v-row no-gutters>
                                <v-autocomplete
                                    class="px-4"
                                    :items="opciones.holidayType"
                                    v-model="holidaysForm.type"
                                    :item-text="encoded => getHolidayTypeTitle(encoded)"
                                    item-value="encoded"
                                    prepend-inner-icon="mdi-list-box-outline"
                                    label="Tipo"
                                    clearable
                                >
                                </v-autocomplete>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-card elevation="0" dense class="py-2 px-4 my-2">
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Justificante
                        </h4>
                    </v-row>
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-card elevation="0" flat>
                        <v-card-text>
                            <div 
                                id="exportForm"
                                @drop="handleFileDrop"
                                class="bg-grey"
                            >
                                <v-icon 
                                    v-if="holidaysForm.file" 
                                    large 
                                    color="red" 
                                    class="deleteBtn"
                                    @click="holidaysForm.file = null"
                                    >mdi-delete
                                </v-icon>
                                <v-container
                                    fluid 
                                    fill-height
                                    class="d-flex justify-center align-center"
                                >
                                    <div v-if="!holidaysForm.file" class="d-flex flex-column">
                                        <v-icon size="100"> mdi-file-sign </v-icon>
                                        <div class="text-center overline font-weight-light">
                                            Arrastre el archivo con el justificante o haga click para abrir el explorador de archivos
                                        </div>
                                    </div>
                                    <div v-else class="d-flex justify-center">
                                        <v-badge class="" color="error" icon="mdi-arrow-up-bold" overlap>
                                            <v-icon color="green accent-1" size="100">
                                                mdi-file-document-edit-outline
                                            </v-icon>
                                            <div class="overline">
                                                <small>{{ holidaysForm.file.name.slice(0, 15) }}</small>
                                            </div>
                                            <div class="grey--text overline">
                                                {{ (holidaysForm.file.size / (1024 * 1024)).toFixed(1) }} MB
                                            </div>
                                        </v-badge>
                                    </div>
                                </v-container>
                                <input
                                    :style="holidaysForm.file ? 'top: 70px' : 'top: 0px'"
                                    type="file"
                                    name="file-input"
                                    @change="handleFileInput"
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card>
                <v-card elevation="0" dense class="py-2 px-4 my-2">
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Mes al que aplica
                        </h4>
                    </v-row>
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row class="d-flex justify-center">
                        <v-col cols="12" class="mb-md-n2">
                            <v-date-picker
                                range
                                v-model="dateFilter"
                                full-width
                                class="mt-4 elevation-0"
                                :events="festiveDaysParse"
                                event-color="red"
                                :first-day-of-week="1"
                            >
                                <v-row no-gutters class="d-flex justify-center">
                                    <v-col
                                        cols="6"
                                        class="d-flex justify-center"
                                    >
                                        <v-btn
                                            outlined
                                            @click="setToday()"
                                            color="yellow darken-3"
                                        >
                                            Hoy
                                            <v-icon right dark>
                                                mdi-calendar-today
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        class="d-flex justify-center"
                                    >
                                        <v-btn
                                            outlined
                                            @click="setNull()"
                                            color="red darken-1"
                                        >
                                            Borrar
                                            <v-icon right dark>
                                                mdi-delete-clock-outline
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-date-picker>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn
                    depressed
                    :disabled="!dateFilter || !holidaysForm.type || !holidaysForm.commercial"
                    color="success"
                    @click="submit"
                >
                    Guardar
                </v-btn>
                <v-btn
                    text
                    color="red"
                    @click="close()"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import defaultHolidaysForm from '@/util/rrhh/defaultHolidaysForm.js';
import { clone, estadoComercial } from '@/util/libUtil.js';

export default {
    name: 'HolidaysForm',
    data: () => ({
        estadoComercial,
        types: [],
        rol: [],
        dateFilter: [],
        selectedComerciales: [],
        allowedExtensions: ['pdf'],
    }),
    methods: {
        handleFileDrop(e) {
            let droppedFiles = e.dataTransfer.files;
            let fileExtention = droppedFiles[0].name.split('.').pop();

            if (!droppedFiles) return;
            else {
                this.holidaysForm.file = null;

                    if (this.allowedExtensions.includes(fileExtention)) {
                        this.holidaysForm.file = droppedFiles[0];
                    } else {
                        this.$store.dispatch(
                            'util/showStatusSnackBar',
                            {
                                statusType: 'error',
                                message:
                                    'El archivo ' +
                                    droppedFiles[0].name +
                                    ' no es del tipo correcto',
                            },
                            { root: true }
                        );
                    }
            }
        },
        handleFileInput(e) {
            let files = e.target.files;
            let fileExtention = files[0].name.split('.').pop();

            if (!files) return;
            else {
                this.holidaysForm.file = null;

                if (this.allowedExtensions.includes(fileExtention)) {
                    this.holidaysForm.file = files[0];
                } else {
                    this.$store.dispatch(
                        'util/showStatusSnackBar',
                        {
                            statusType: 'error',
                            message:
                                'El archivo ' +
                                files[0].name +
                                ' no es del tipo correcto',
                        },
                        { root: true }
                    );
                }
            }
        },
        submit() {
            if (this.holidaysFormType == 'CREATE') this.createHoliday();
            else {
                this.holidaysForm.begin = new Date(this.holidaysForm.begin).toISOString().substr(0, 10)
                this.holidaysForm.end = new Date(this.holidaysForm.end).toISOString().substr(0, 10)
                this.holidaysForm.commercial = this.holidaysForm.commercial.id ?? this.holidaysForm.commercial 
                this.editHoliday();
            }

            close();
        },
        setNull() {
            this.dateFilter = [];
        },
        setToday() {
            this.dateFilter = [];
            this.dateFilter.push(
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
            );
        },
        close() {
            this.types = [];
            this.rol = [];
            this.holidaysForm = clone(defaultHolidaysForm);
            this.dateFilter = [];
            this.isOpenHolidaysForm = false;
        },
        getHolidayTypeTitle(value) {
            const split = value.encoded.toLowerCase().replaceAll('_', ' ').split(' ');
            return split
                .map((word) => word[0].toUpperCase() + word.slice(1))
                .join(' ');
        },
        ...mapActions('holidays', ['createHoliday', 'editHoliday']),
    },
    computed: {
        festiveDaysParse(){
            return this.festiveDays.map(({date}) => new Date(date).toISOString().substr(0, 10))
        },
        comercialesFilter() {
            return this.rol.length == 0 && this.types.length == 0
                ? this.comerciales
                : this.comerciales.filter(
                      (comercial) =>
                          this.rol.some((rol) => rol == comercial.rol?.id) ||
                          this.types.some(
                              (type) => type == comercial.tipoComercial
                          )
                  );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        isOpenHolidaysForm: {
            get() {
                return this.$store.state.holidays.isOpenHolidaysForm;
            },
            set(val) {
                return this.$store.commit('holidays/isOpenHolidaysForm', val);
            },
        },
        holidaysForm: {
            get() {
                return this.$store.state.holidays.holidaysForm;
            },
            set(val) {
                return this.$store.commit('holidays/holidaysForm', val);
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
        ...mapState('holidays', {
            holidaysFormType: (state) => state.holidaysFormType,
            festiveDays: (state) => state.workingCalendarObj.workingCalendar,
        }),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
    watch: {
        dateFilter() {
            // Si la primera fecha es mayor que la segunda reordenamos
            if (
                this.dateFilter &&
                this.dateFilter.length == 2 &&
                this.dateFilter[0] > this.dateFilter[1]
            ) {
                let aux = this.dateFilter[0];
                this.dateFilter[0] = this.dateFilter[1];
                this.dateFilter[1] = aux;
            }

            if (this.dateFilter.length == 1) {
                this.holidaysForm.begin = this.dateFilter[0];
                this.holidaysForm.end = this.dateFilter[0];
            } else {
                this.holidaysForm.begin = this.dateFilter[0];
                this.holidaysForm.end = this.dateFilter[1];
            }
        },
    },
    beforeMount(){
        if(!this.hasAdminPermission) {
            this.holidaysForm.commercial = JSON.parse(localStorage.getItem('cuenta'))
        }
    }
};
</script>

<style scoped>
.deleteBtn {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 10px;
}

#exportForm input {
    cursor: pointer;
    opacity: 0;
    width: 100%;
    height: 100%;
    height: 200px;
    position: absolute;
    top: 350px;
    left: 0;
    right: 0;
    bottom: 0;
}

.bg-grey {
    border-radius: 10px;
}
</style>